import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';

export const RootWrapper = styled(Box)(() => ({
  overflowX: 'clip',
  position: 'relative',
}));

export const GridWrapper = styled(Grid)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(3),
}));

export const NavBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: theme.spacing(6.25),
  alignItems: 'end',
  justifyContent: 'center',
  background: theme.palette.common.black,
  color: theme.palette.common.white,
}));

export const FlexRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  paddingRight: theme.spacing(2),
  gap: theme.spacing(1),
}));
